import { Injectable } from '@angular/core';
import GroupsCounter, { GroupData } from '../tools/groups-counter';

export enum CounterGroups {
	PAGE_LOAD = 1,
	CONTAINER_LOAD = 2,
	FILTERS_LOAD = 3,
}

@Injectable({
	providedIn: 'root'
})
export class LoadingIndicationService {
	private _isLoadingGroupsCounter: GroupsCounter<CounterGroups> = new GroupsCounter<CounterGroups>();
	public get isLoadingGroupsCounter(): GroupsCounter<CounterGroups> {
		return this._isLoadingGroupsCounter;
	}

	public isLoading: boolean = false;

	// private _isLoading = new BehaviorSubject<boolean>(false);
	// public isLoading$: Observable<boolean> = this._isLoading.asObservable();

	private _loadingLocked: boolean = false;

	public lockLoading(): void {
		this._loadingLocked = true;

		this.isLoading = true;
	}

	public unlockLoading(): void {
		this._loadingLocked = false;

		if (!this._isLoadingGroupsCounter.hasActiveEntries(CounterGroups.PAGE_LOAD)) {
			this.isLoading = false;
		}
	}

	public register(options: { groupType: CounterGroups, groupId: string }, debugName?: string, debug: boolean = true): void {
		this._isLoadingGroupsCounter.increase(
			options.groupType,
			options.groupId,
			debugName,
			debug
		);
	}

	public unregister(options: { groupType: CounterGroups, groupId: string }, debugName?: string, debug: boolean = true): void {
		this._isLoadingGroupsCounter.decrease(
			options.groupType,
			options.groupId,
			debugName,
			debug
		);
	}

	constructor() {
		this._isLoadingGroupsCounter.getOnIncreaseSubject(CounterGroups.PAGE_LOAD).subscribe(
			(value: Map<string, GroupData>) => {
				let total = 0;

				for (const groupData of value.values()) {
					total += groupData.quantity;
				}

				if (!this._loadingLocked && total > 0 && !this.isLoading) {
					// this._isLoading.next(true);

					// setTimeout(() => {
						this.isLoading = true;
					// }, 0);
				}
			}
		);

		this._isLoadingGroupsCounter.getOnDecreaseSubject(CounterGroups.PAGE_LOAD).subscribe(
			(value: Map<string, GroupData>) => {
				let total = 0;

				for (const groupData of value.values()) {
					total += groupData.quantity;
				}

				if (!this._loadingLocked && total === 0 && this.isLoading) {
					// this._isLoading.next(false);

					// setTimeout(() => {
						this.isLoading = false;
					// }, 0);
				}
			}
		);
	}
}
